import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slide, Box } from "@mui/material";
import { forwardRef } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import { logoutStyles } from "../../styles/layout";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

// Slide transition effect
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const LogoutModel = ({ openDialog, setOpenDialog }) => {
    const theme = useTheme();
    const classes = logoutStyles(theme);
    const navigation = useNavigate();
    return (
        <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            slots={{ transition: Transition }}
            keepMounted
            maxWidth="xs"
            fullWidth
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 2,
                        p: 2,
                        boxShadow: 6,
                        width: 500,
                    },
                },
            }}

        >
            {/* Icon on top */}
            <Box sx={classes.rootDiv}>
                <LogoutIcon color="error" sx={{ fontSize: 50 }} />
            </Box>

            <DialogTitle sx={classes.title}>
                Sign Out
            </DialogTitle>

            <DialogContent>
                <DialogContentText sx={classes.subtitle}>
                    Are you sure you want to sign out?
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={classes.btnDiv}>
                <Button
                    variant="outlined"
                    onClick={() => setOpenDialog(false)}
                    sx={{ borderRadius: 2 }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => { navigation("/");  }}
                    color="error"
                    variant="contained"
                    sx={{ borderRadius: 2, px: 3 }}
                    
                >
                    Sign Out
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LogoutModel;
